import { DeviceTypeIcon } from './DeviceTypeIcon';

export default DeviceTypeIcon;
